import $ from 'jquery';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import layout from '../Layout';
import ProductItem from '../snippets/ProductItem';

export default class ProductHighlights {
  constructor($el, postMessage) {
    this.$el = $el;
    this.postMessage = postMessage;
    this.$productHighlightsMobile = $('.product-highlights-mobile-wrapper', this.$el);
    this.callback = this._init.bind(this);

    if (!this.$productHighlightsMobile.length) {
      return;
    }

    // Product items
    this.productItems = [];
    const $productItems = $('[data-product-item]', this.$el);
    if ($productItems.length) {
      for (const productItem of $productItems) {
        this.productItems.push(
          new ProductItem($(productItem), this.postMessage)
        );
      }
    }

    this._bindEvents();
    this._init();
  }

  _bindEvents() {
    layout.onBreakpointChange(this.callback);
  }

  _unbindEvents() {
    layout.offBreakpointChange(this.callback);
  }

  _init() {
    if (layout.isBreakpoint('M') || layout.isBreakpoint('S')) {
      this._initFlickity();
    } else {
      this._destroyFlickity();
    }
  }

  _initFlickity() {
    if (!this.flickity) {
      this.flickity = new Flickity(this.$productHighlightsMobile[0], {
        cellSelector: '[data-product-item]',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        selectedAttraction: 0.02,
        imagesLoaded: true,
      });
    }
  }

  _destroyFlickity() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
      $('[data-product-item]', this.$el).attr('style', '');
    }
  }

  unload() {
    this._unbindEvents();

    if (this.productItems) {
      for (const productItem of this.productItems) {
        productItem.unload();
      }
    }
  }
}
